<template>
  <v-container>
    <v-dialog
        v-model="showPasswordDialog"
        scrollable
        max-width="300px"
        persistent>
      <v-card>
        <v-card-title>Passwort</v-card-title>
        <v-card-text>
          <v-text-field type="password" label="Passwort eingeben" v-model="dialog_password"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text :disabled="this.password_ok_disabled" @click="onPasswordEnter">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <h1>Neues Wort hinzufügen</h1>
    <upload-soundfile ref="gtUpload" label="Gailtal"
                      @change="onAudioChange(Regions.GAILTAL, $event)"></upload-soundfile>
    <upload-soundfile ref="jtUpload" label="Jauntal"
                      @change="onAudioChange(Regions.JAUNTAL, $event)"></upload-soundfile>
    <upload-soundfile ref="rtUpload" label="Rosental"
                      @change="onAudioChange(Regions.ROSENTAL, $event)"></upload-soundfile>
    <v-text-field label="Name" v-model="name"></v-text-field>
    <v-btn block color="primary" @click="upload" :disabled="submit_disabled">Hinzufügen</v-btn>
    <v-btn block color="secondary" @click="cancel">Zurück</v-btn>
  </v-container>
</template>

<script>
import UploadSoundfile from "@/components/UploadSoundfile";

export default {
  name: "CreateWord",
  components: {UploadSoundfile},
  data: () => ({
    dialog_password: null,
    password: null,
    file_gailtal: null,
    file_jauntal: null,
    file_rosental: null,
    name: "",
    Regions: {
      GAILTAL: "Gailtal",
      JAUNTAL: "Jauntal",
      ROSENTAL: "Rosental"
    }
  }),

  methods: {
    onPasswordEnter() {
      if (!this.password_ok_disabled) {
        this.password = this.dialog_password;
      }
    },
    onAudioChange(region, file) {
      switch (region) {
        case this.Regions.GAILTAL:
          this.file_gailtal = file;
          break;
        case this.Regions.JAUNTAL:
          this.file_jauntal = file;
          break;
        case this.Regions.ROSENTAL:
          this.file_rosental = file;
          break;
      }
      if (!file) return;

      if (this.name == null || this.name.trim().length === 0) {
        const lastUnderline = file.name.lastIndexOf("_");
        this.name = file.name.substring(0, lastUnderline);
      }
    },

    async upload() {
      try {
        await this.$wordService.addWord(this.name, this.file_gailtal, this.file_jauntal, this.file_rosental, this.password);
        alert("Wort erfolgereich hinzugefügt");
        this.file_gailtal = this.file_jauntal = this.file_rosental = null;
        this.name = null
        this.$refs.gtUpload.clear();
        this.$refs.jtUpload.clear();
        this.$refs.rtUpload.clear();
      } catch (e) {
        console.log(e);
        if (e.response && e.response.status === 401) {
          this.dialog_password = this.password = null;
        } else if (e.response && e.response.data) {
          alert(e.response.data);
        } else {
          alert("Ein allgemeiner Fehler ist aufgetreten");
        }
      }
    },

    cancel() {
      this.$router.go(-1);
    }
  },

  computed: {
    submit_disabled() {
      return (!this.file_gailtal && !this.file_rosental && !this.file_jauntal) || !this.name;
    },

    password_ok_disabled() {
      return this.dialog_password == null || this.dialog_password.trim() === '';
    },

    showPasswordDialog() {
      return this.password == null || this.password.trim() === '';
    }
  }
}
</script>

<style scoped>
.v-btn {
  margin-bottom: .5em;
}
</style>
